import React from "react";
import { Routes, Route } from "react-router-dom";
import HeaderRanking from "../Components/Ranking/headerRanking";
import ListBuilderRating from "../Components/Ranking/listBuilderRanking";
import ListProjectRating from "../Components/Ranking/listProjectRanking";
import ListProjectVideoRating from "../Components/Ranking/listVideoRanking";

const RankingRoutes = () => {
  return (
    <Routes>
      <Route path="/ranking" element={<HeaderRanking></HeaderRanking>}></Route>
      <Route path="/ranking_builder_list" element={<ListBuilderRating></ListBuilderRating>}></Route>
      <Route path="/ranking_project_list" element={<ListProjectRating></ListProjectRating>}></Route>
      <Route path="/ranking_video_list" element={<ListProjectVideoRating></ListProjectVideoRating>}></Route>
    </Routes>
  );
};

export default RankingRoutes;
